export enum ActionType {
    ON = "on",
    OFF = "off",
    GET_MENU = "get-menu"
}